module.exports = __webpack_public_path__ + "985af29f8d29219d9de62c7f01753727.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/quarantaene_rr.jpg
// module id = 814
// module chunks = 0